import React, { Fragment } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { Card, CardBody, CardHeader, Col, Container, Row, Label, Collapse, Table, Nav, NavItem, NavLink, TabContent, TabPane, Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import BreadCrumb from '../components/Common/BreadCrumb';
import Flatpickr from "react-flatpickr";
import dateFormat from "dateformat";
import moment from "moment";
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';

import { createDeepClone, buildDownloadUrl } from "../utils/index";

import CardLoader from "../components/CardLoader";
import ActionList from "../components/ActionList";
import Lookup from "../components/Lookup";
import MyDateRenderer from "../components/MyDateRenderer";
import MyNumberRenderer from "../components/MyNumberRenderer";
import CustomerLookup from "../components/CustomerLookup";
import { Highlighter, Menu, MenuItem } from 'react-bootstrap-typeahead';
import ConfirmModal from "../components/ConfirmModal";
import ConfirmModalAdvanced from "../components/ConfirmModalAdvanced";
import GoogleMapModal from "../components/GoogleMapModal";
import IdiServiceDocumentGrid from "../components/IdiServiceDocumentGrid";
import CommentGrid from "../components/CommentGrid";
import ErrorModal from "../components/ErrorModal";
import MyFlatPicker from "../components/MyFlatPicker";
import IdiInspectionINR from "../components/IdiInspectionINR";
import IdiInspectionRD5 from "../components/IdiInspectionRD5";
import IdiInspectionRD7 from "../components/IdiInspectionRD7";
import IdiInspectionRD3 from "../components/IdiInspectionRD3";
import IdiInspectionRD6 from "../components/IdiInspectionRD6";

import { useDispatch, useSelector } from "react-redux";
import * as idiInspectionActions from "../actions/IdiInspectionActions";
import * as commonActions from "../actions/CommonActions";

const IdiInspectionEditScreen  = (props) => {
    const { register, clearErrors, reset, trigger, formState: { errors } } = useForm({mode: 'all'});

    const navigate = useNavigate();
    const { id } = useParams();

    const dispatch = useDispatch();

    const loading = useSelector((state) => state.idiinspection.loadingFBO);
    const user = useSelector((state) => state.login.user);
    const fbo = useSelector((state) => state.idiinspection.fbo);

    const [fboState, setFBOState] = React.useState(fbo);
    const [isDirty, setIsDirty] = React.useState(false);
    const [refreshAction, setRefreshAction] = React.useState(false);
    const [selectedCustomer, setSelectedCustomer] = React.useState([]);
    const [selectedOwner, setSelectedOwner] = React.useState([]);
    const [selectedInspector, setSelectedInspector] = React.useState([]);

    const [loadingLocal, setLoadingLocal] = React.useState(false);
    const [selectedStatus, setSelectedStatus] = React.useState("");
    const [currentMessage, setCurrentMessage] = React.useState("");    
    
    const [showSubmitModal, setShowSubmitModal] = React.useState(false);
    const [showInspectionInProcessModal, setShowInspectionInProcessModal] = React.useState(false);
    const [showReadyForReviewModal, setShowReadyForReviewModal] = React.useState(false);
    const [showApproveModal, setShowApproveModal] = React.useState(false);
    const [showCompletedModal, setShowCompletedModal] = React.useState(false);
    const [showClosedModal, setShowClosedModal] = React.useState(false);
    const [showAbortedModal, setShowAbortedModal] = React.useState(false);
    const [showAssignMeModal, setShowAssignMeModal] = React.useState(false);
    
    const [showGoogleMap, setShowGoogleMap] = React.useState(false);

    const [deleteImageIndex, setDeleteImageIndex] = React.useState(-1);
    const [deleteImageObjectName, setDeleteImageObjectName] = React.useState("");
    const [deleteImageListName, setDeleteImageListName] = React.useState("");
    const [showDeleteImageModal, setShowDeleteImageModal] = React.useState(false);
    
    const [generateDocumentType, setGenerateDocumentType] = React.useState("");
    const [generateDocumentApproved, setGenerateDocumentApproved] = React.useState(false);
    const [showGenerateDocumentModal, setShowGenerateDocumentModal] = React.useState(false);

    const [projectInformationCollapsed, setProjectInformationCollapsed] = React.useState(true);

    React.useEffect(() => {
        dispatch(idiInspectionActions.loadIdiInspection(id, navigate));
    }, [id]);

    React.useEffect(() => {
        setFBOState(fbo);
        setIsDirty(false);
        setRefreshAction(!refreshAction);
        setSelectedCustomer([]);
        setSelectedOwner([]);
        setSelectedInspector([]);
        
        if(fbo) {
            
        }
        
        if(fbo != null) {
            reset(fbo.idiInspection);
            
            if(fbo.customer != null) {
                setSelectedCustomer([fbo.customer]);
            }

            if(fbo.owner != null) {
                setSelectedOwner([fbo.owner]);
            }

            if(fbo.inspector != null) {
                setSelectedInspector([fbo.inspector]);
            }
        }
        
        clearErrors();
    }, [fbo]);

    const reloadAction = () => {
        setRefreshAction(!refreshAction);
    }

    const onChangeDocument = (isProduct) => {
        setRefreshAction(!refreshAction);
    }

    const getFormattedDate = (value) => {
        if(value) {
            return dateFormat(value, "mm/dd/yyyy");
        }
        return "";
    }

    const getFormattedDateTime = (value) => {
        if(value) {
            return dateFormat(value, "mm/dd/yyyy HH:MM");
        }
        return "";
    }

    const getDateWithoutTimezone = (value) => {
        if(value) {
            const tzoffset = value.getTimezoneOffset() * 60000;
            const withoutTimezone = new Date(value.valueOf() - tzoffset).toISOString().slice(0, -1);
            return withoutTimezone;
        }
        return "";
    }

    const onIdiInspectionChange = (name, value, isBlur) => {
        var copy_fboState = createDeepClone(fboState);

        if(value && isBlur) {
            value = value.trim();
        }

        if(value) {
            if(name === "startDate" || name === "endDate" || name === "inspectionDate" || name === "reportDate" || name === "reportIssuanceDate" || name === "previousRd5Date" || name === "inspectionStopDate" || name === "siteWorkStopDate") {
                copy_fboState.idiInspection[name] = getDateWithoutTimezone(value);
            }
            else {
                copy_fboState.idiInspection[name] = value;
            }
        }
        else if(value === false) {
            copy_fboState.idiInspection[name] = false;
        }
        else {
            copy_fboState.idiInspection[name] = null;
        }

        setFBOState(copy_fboState);
        setIsDirty(true);
    }

    const onIdiInspectionInrChange = (name, value, isBlur) => {
        var copy_fboState = createDeepClone(fboState);

        if(value && isBlur) {
            value = value.trim();
        }

        if(value) {
            if(name === "inspectorVersion") {
                value = value.replace(/\D/g, '');
            }

            copy_fboState.idiInspectionInr[name] = value;
        }
        else if(value === false) {
            copy_fboState.idiInspectionInr[name] = false;
        }
        else {
            copy_fboState.idiInspectionInr[name] = null;
        }

        setFBOState(copy_fboState);
        setIsDirty(true);
    }

    const onIdiInspectionRd5Change = (name, value, isBlur) => {
        var copy_fboState = createDeepClone(fboState);

        if(value && isBlur) {
            value = value.trim();
        }

        if(value) {
            if(name === "inspectorVersion" || name === "previousReportCount" || name === "attachedDocumentCount") {
                value = value.replace(/\D/g, '');
            }

            if(name === "workProgressG0" || name === "workProgressS0") {
                value = value.replace(/[^0-9.-]/g, '').replace(/(?!^)-/g, '').replace(/(\..*)\./g, '$1');
            }
            
            if(name === "previousRd5Date" || name === "inspectionStopDate" || name === "siteWorkStopDate") {
                copy_fboState.idiInspectionRd5[name] = getDateWithoutTimezone(value);
            }
            else {
                copy_fboState.idiInspectionRd5[name] = value;
            }
        }
        else if(value === false) {
            copy_fboState.idiInspectionRd5[name] = false;
        }
        else {
            copy_fboState.idiInspectionRd5[name] = null;
        }

        setFBOState(copy_fboState);
        setIsDirty(true);
    }

    const onIdiInspectionRd7Change = (name, value, isBlur) => {
        var copy_fboState = createDeepClone(fboState);

        if(value && isBlur) {
            value = value.trim();
        }

        if(value) {
            if(name === "inspectorVersion") {
                value = value.replace(/\D/g, '');
            }

            if(name === "foundationPercentage" || name === "structurePercentage" || name === "waterproofingPercentage" || name === "foundationBaseDepth") {
                value = value.replace(/[^0-9.-]/g, '').replace(/(?!^)-/g, '').replace(/(\..*)\./g, '$1');
            }
            
            if(name === "commencementDate" || name === "expectedCompletionDate" || name === "firstVisitDate" || name === "eventDate") {
                copy_fboState.idiInspectionRd7[name] = getDateWithoutTimezone(value);
            }
            else {
                copy_fboState.idiInspectionRd7[name] = value;
            }
        }
        else if(value === false) {
            copy_fboState.idiInspectionRd7[name] = false;
        }
        else {
            copy_fboState.idiInspectionRd7[name] = null;
        }

        setFBOState(copy_fboState);
        setIsDirty(true);
    }

    const onIdiInspectionRd3Change = (name, value, isBlur) => {
        var copy_fboState = createDeepClone(fboState);

        if(value && isBlur) {
            value = value.trim();
        }

        if(value) {
            if(name === "inspectorVersion") {
                value = value.replace(/\D/g, '');
            }
            
            if(name === "workStartDate" || name === "workAchievementDate" || name === "lastSiteVisitDate" || name === "occupancyCertificateDate"|| name === "InceptionDate" || name === "annex1RoofTestWaterPondingDate") {
                copy_fboState.idiInspectionRd3[name] = getDateWithoutTimezone(value);
            }
            else {
                copy_fboState.idiInspectionRd3[name] = value;
            }
        }
        else if(value === false) {
            copy_fboState.idiInspectionRd3[name] = false;
        }
        else {
            copy_fboState.idiInspectionRd3[name] = null;
        }

        setFBOState(copy_fboState);
        setIsDirty(true);
    }

    const onIdiInspectionRd3EntryChange = (rd3EntryIndex, rd3EntryType, obj_entry) => {
        var copy_fboState = createDeepClone(fboState);

        if(rd3EntryIndex !== -1) {
            var item = null;
            
            if(rd3EntryType === "T1") {
                item = copy_fboState.idiInspectionRd3.t1EntryList[rd3EntryIndex];
            }
            else if(rd3EntryType === "T2") {
                item = copy_fboState.idiInspectionRd3.t2EntryList[rd3EntryIndex];
            }
            else if(rd3EntryType === "T3") {
                item = copy_fboState.idiInspectionRd3.t3EntryList[rd3EntryIndex];
            }
            else if(rd3EntryType === "T4") {
                item = copy_fboState.idiInspectionRd3.t4EntryList[rd3EntryIndex];
            }
            else if(rd3EntryType === "T5") {
                item = copy_fboState.idiInspectionRd3.t5EntryList[rd3EntryIndex];
            }

            if (item) {
                Object.assign(item, {
                    entryType: obj_entry.rd3EntryType,
                    entryId: obj_entry.rd3EntryId,
                    entryRd3Id: obj_entry.rd3EntryRd3Id,
                    documentName: obj_entry.rd3EntryDocumentName,
                    description: obj_entry.rd3EntryDescription,
                    annexNo: obj_entry.rd3EntryAnnexNo,
                    issuanceMinuteNo: obj_entry.rd3EntryIssuanceMinuteNo,
                    cancellationMinuteNo: obj_entry.rd3EntryCancellationMinuteNo,
                    orderNo: obj_entry.rd3EntryOrderNo,
                    orderDate: obj_entry.rd3EntryOrderDate,
                    inspector: obj_entry.rd3EntryInspector,
                    controlledItem: obj_entry.rd3EntryControlledItem
                });
            }
        }
        else {
            if(rd3EntryType === "T1") {
                copy_fboState.idiInspectionRd3.t1EntryList.push(obj_entry);
            }
            else if(rd3EntryType === "T2") {
                copy_fboState.idiInspectionRd3.t2EntryList.push(obj_entry);
            }
            else if(rd3EntryType === "T3") {
                copy_fboState.idiInspectionRd3.t3EntryList.push(obj_entry);
            }
            else if(rd3EntryType === "T4") {
                copy_fboState.idiInspectionRd3.t4EntryList.push(obj_entry);
            }
            else if(rd3EntryType === "T5") {
                copy_fboState.idiInspectionRd3.t5EntryList.push(obj_entry);
            }
        }

        setFBOState(copy_fboState);
        setIsDirty(true);
    }

    const onIdiInspectionRd6Change = (name, value, isBlur) => {
        var copy_fboState = createDeepClone(fboState);

        if(value && isBlur) {
            value = value.trim();
        }

        if(value) {
            if(name === "inspectorVersion") {
                value = value.replace(/\D/g, '');
            }

            if(name === "sumInsuredRd0" || name === "sumInsuredFinal") {
                value = value.replace(/[^0-9.-]/g, '').replace(/(?!^)-/g, '').replace(/(\..*)\./g, '$1');
            }
            
            if(name === "workStartDate" 
                || name === "lastSiteVisitDate"
                || name === "workAchievementDate"
                || name === "occupancyCertificateDate"
                || name === "rd0ReportIssueDate"
                || name === "rd1ReportIssueDate"
                || name === "rd2ReportIssueDate"
                || name === "rd6ReportIssueDate"
                || name === "rd7ReportIssueDate"
                || name === "rd7CommencedReportIssueDate"
                || name === "rd7InterruptionReportIssueDate"
                || name === "rd7AccidentReportIssueDate"
                || name === "rd7IncidenceReportIssueDate"
                || name === "roofTestWaterPondingDate"
                || name === "defectNotRepairedIssuingDate" ) {
                copy_fboState.idiInspectionRd6[name] = getDateWithoutTimezone(value);
            }
            else {
                copy_fboState.idiInspectionRd6[name] = value;
            }
        }
        else if(value === false) {
            copy_fboState.idiInspectionRd6[name] = false;
        }
        else {
            copy_fboState.idiInspectionRd6[name] = null;
        }

        setFBOState(copy_fboState);
        setIsDirty(true);
    }

    const onTeamLeadChange = (value) => {
        var copy_fboState = createDeepClone(fboState);
        
        if(value == 0) {
            copy_fboState.idiInspection["teamLeadUserId"] = null;
        }
        else {
            copy_fboState.idiInspection["teamLeadUserId"] = value;
        }
                
        setFBOState(copy_fboState);
        setIsDirty(true);
    }

    const onInspectorChange = (item) => {
        var copy_fboState = createDeepClone(fboState);
        setSelectedInspector(item);
        
        if(item.length > 0) {
            copy_fboState.idiInspection["inspectorUserId"] = item[0].id.toString();
        }
        else {
            copy_fboState.idiInspection["inspectorUserId"] = null;
        }

        setFBOState(copy_fboState);
        setIsDirty(true);
    }

    const onQuestionChange = (index, name, value, isBlur) => {
        var copy_fboState = createDeepClone(fboState);

        if(value && isBlur) {
            value = value.trim();
        }

        if(value) {
            copy_fboState.idiInspectionInr.questionList[index][name] = value;
        }
        else if(value === false) {
            copy_fboState.idiInspectionInr.questionList[index][name] = false;
        }
        else {
            copy_fboState.idiInspectionInr.questionList[index][name] = null;
        }

        copy_fboState.idiInspectionInr.questionList[index]["isModified"] = true;

        setFBOState(copy_fboState);
        setIsDirty(true);
    }

    const onImageChange = (index, objectName, listName, name, value, isBlur) => {
        var copy_fboState = createDeepClone(fboState);

        if(value && isBlur) {
            value = value.trim();
        }

        if(value) {
            copy_fboState[objectName][listName][index][name] = value;

        }
        else if(value === false) {
            copy_fboState[objectName][listName][index][name] = false;
        }
        else {
            copy_fboState[objectName][listName][index][name] = null;
        }

        copy_fboState[objectName][listName][index]["isModified"] = true;

        setFBOState(copy_fboState);
        setIsDirty(true);
    }

    const onImageFileChange = async (index, objectName, listName, event) => {
        if(event.target.files.length > 0) {
            const formData = new FormData();

            formData.append("idiInspectionImage", JSON.stringify(fboState[objectName][listName][index]));
            formData.append("file", event.target.files[0]);

            setLoadingLocal(true);

            var data = await idiInspectionActions.saveDocument(formData);
            if(data.error) {
                dispatch(commonActions.setErrorMessage(data.error));
            }
            else {
                var copy_fboState = createDeepClone(fboState);
                copy_fboState[objectName][listName][index]["documentId"] = data.image.documentId;
                copy_fboState[objectName][listName][index]["isModified"] = true;
                setFBOState(copy_fboState);

                dispatch(commonActions.setSuccessMessage("Image Added Successfully!"));
                reloadAction();
            }

            setLoadingLocal(false);
        }
    }

    const onImageFileDelete = (index, objectName, listName) => {
        setDeleteImageIndex(index);
        setDeleteImageObjectName(objectName);
        setDeleteImageListName(listName);
        setShowDeleteImageModal(true);
    }

    const onCloseImageFileDelete = () => {
        setDeleteImageIndex(-1);
        setDeleteImageObjectName("");
        setDeleteImageListName("");
        setShowDeleteImageModal(false);
    }

    const onSaveImageFileDelete = async () => {
        if(deleteImageIndex >= 0) {
            var deletedIndex = deleteImageIndex;
            var objectName = deleteImageObjectName;
            var listName = deleteImageListName;

            onCloseImageFileDelete();

            setLoadingLocal(true);

            var data = await idiInspectionActions.deleteDocument(fboState[objectName][listName][deletedIndex]);
            if(data.error) {
                dispatch(commonActions.setErrorMessage(data.error));
            }
            else {
                var copy_fboState = createDeepClone(fboState);
                copy_fboState[objectName][listName][deletedIndex]["documentId"] = null;
                copy_fboState[objectName][listName][deletedIndex]["isModified"] = true;
                setFBOState(copy_fboState);

                dispatch(commonActions.setSuccessMessage("Image Deleted Successfully!"));
                reloadAction();
            }

            setLoadingLocal(false);
        }
    }

    const onGenerateDocument = async (documentType, approved) => {
        setGenerateDocumentType(documentType);
        setGenerateDocumentApproved(approved);
        setShowGenerateDocumentModal(true);
    }

    const onSaveGenerateDocument = async () => {
        setShowGenerateDocumentModal(false);

        setLoadingLocal(true);
        var data = await idiInspectionActions.generateDocument(fboState.idiInspection.id, generateDocumentType, generateDocumentApproved);
        setLoadingLocal(false);

        if(data.success) {
            dispatch(commonActions.setSuccessMessage(data.successMessage));
            dispatch(idiInspectionActions.loadIdiInspection(id, navigate));
        }
        else{
            dispatch(commonActions.setErrorMessage(data.errorMessage));
        }

        setCurrentMessage("");
        reloadAction();
    }

    const onCloseGenerateDocument = () => {
        setGenerateDocumentType("");
        setGenerateDocumentApproved(false);
        setShowGenerateDocumentModal(false);
    }

    

    const onSaveIdiInspection = async(skipValidation) => {
        var valid = true;

        if(!skipValidation) {
            valid = await trigger();
        }

        if(valid) {
            dispatch(idiInspectionActions.saveIdiInspection(fboState, selectedStatus, currentMessage, navigate));
        }
        
        onCloseModalClick();
    }

    const onCancelIdiInspection = () => {
        setFBOState(fbo);

        if(fbo.customer != null) {
            setSelectedCustomer([fbo.customer]);
        }
        else {
            setSelectedCustomer([]);
        }

        if(fbo.owner != null) {
            setSelectedOwner([fbo.owner]);
        }
        else {
            setSelectedOwner([]);
        }

        if(fbo.inspector != null) {
            setSelectedInspector([fbo.inspector]);
        }
        else {
            setSelectedInspector([]);
        }

        setIsDirty(false);
        clearErrors();
    }

    const onSubmitIdiInspectionClick = () => {
        setSelectedStatus("Pending for Inspection");
        setCurrentMessage("");
        setShowSubmitModal(true);
    }

    const onInspectionInProcessIdiInspectionClick = () => {
        setSelectedStatus("Inspection In Process");
        setCurrentMessage("");
        setShowInspectionInProcessModal(true);
    }

    const onReadyForReviewIdiInspectionClick = () => {
        setSelectedStatus("Ready for Review");
        setCurrentMessage("");
        setShowReadyForReviewModal(true);
    }

    const onApproveIdiInspectionClick = () => {
        setSelectedStatus("Approve");
        setCurrentMessage("");
        setShowApproveModal(true);
    }

    const onCompletedIdiInspectionClick = () => {
        setSelectedStatus("Completed");
        setCurrentMessage("");
        setShowCompletedModal(true);
    }

    const onClosedIdiInspectionClick = () => {
        setSelectedStatus("Closed");
        setCurrentMessage("");
        setShowClosedModal(true);
    }

    const onAbortedIdiInspectionClick = () => {
        setSelectedStatus("Aborted");
        setCurrentMessage("");
        setShowAbortedModal(true);
    }

    const onAssignMeInspectionClick = () => {
        setShowAssignMeModal(true);
    }

    const onAssignMeInspection = async () => {
        dispatch(idiInspectionActions.assignIdiInspection(fboState.idiInspection.id, user.id, true, navigate));
        onCloseModalClick();
    }

    const onCloseModalClick = () => {
        setSelectedStatus("");
        setCurrentMessage("");

        setShowSubmitModal(false);
        setShowInspectionInProcessModal(false);
        setShowReadyForReviewModal(false);
        setShowApproveModal(false);
        setShowCompletedModal(false);
        setShowClosedModal(false);
        setShowAbortedModal(false);
        setShowAssignMeModal(false);

        setShowGoogleMap(false);
        setShowDeleteImageModal(false);
        setShowGenerateDocumentModal(false);
    }
    
    const InspectorRenderer = (results, menuProps, props) => (
        <Menu id="menuCustomerLookup" style={{minWidth:600}}>
            <div className="container">
                <div className="row font-weight-bold border-bottom">
                    <div className="col">Inspector Name</div>
                    <div className="col">Email</div>
                    <div className="col">Emp ID #</div>
                    <div className="col">Distance</div>
                    <div className="col" style={{textAlign:"right"}}>View Calendar</div>
                </div>
            </div>
            {results.length == 0 && <div style={{padding:5}}>No Macthes Found...</div>}
            {results.map((result, idx) => (
                <MenuItem
                    key={idx}
                    option={result}
                    position={idx}>
                    <div className="row border-bottom">
                        <div className="col" style={{wordBreak: "break-all", whiteSpace: "normal"}}>
                            <Highlighter search={props.text}>
                                {result.fullName || ""}
                            </Highlighter>
                        </div>
                        <div className="col" style={{wordBreak: "break-all", whiteSpace: "normal"}}>
                            <Highlighter search={props.text}>
                                {result.email || ""}
                            </Highlighter>
                        </div>
                        <div className="col" style={{wordBreak: "break-all", whiteSpace: "normal"}}>
                            <Highlighter search={props.text}>
                                {result.employeeId || ""}
                            </Highlighter>
                        </div>
                        <div className="col" style={{wordBreak: "break-all", whiteSpace: "normal"}}>
                            <MyNumberRenderer value={result.distanceKm || ""} /> {result.distanceKm ? "KM" : ""}
                        </div>
                        <div className="col" style={{wordBreak: "break-all", whiteSpace: "normal"}}>
                            <a
                                className="btn btn-outline-primary btn-icon float-end btn-sm"
                                title="View Inspector Calendar"
                                style={{marginBottom:5}}
                                target="_blank"
                                href={`/idi-calendar/${result.id}`}
                                onClick={(e) => e.stopPropagation()}
                            >
                                <i className="ri-calendar-line"></i>
                            </a>
                        </div>
                    </div>
                </MenuItem>
            ))}
        </Menu>
    )

    return(
        <Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title={`Edit IDI Inspection`} />
                    <Row>
                        <Col lg={9}>
                            <CardLoader loading={loading || loadingLocal} />

                            <Card className="mb-0">
                                <CardHeader className="border-0 d-flex align-items-center">
                                    <h5 className="card-title mb-0 flex-grow-1">
                                        IDI Inspection
                                    </h5>
                                    <div className="flex-shrink-1 ms-3">
                                        <div className="d-flex flex-wrap gap-2">
                                            {fboState && fboState.canSave &&
                                            <button className="btn btn-primary btn-label"
                                                disabled={loading || !isDirty}
                                                onClick={() => onSaveIdiInspection(true)}
                                            >
                                                <i className="ri-save-line label-icon align-middle"></i> Save IDI Inspection
                                            </button>
                                            }
                                            {fboState && fboState.canSave &&
                                            <button className="btn btn-danger btn-label"
                                                disabled={loading || !isDirty}
                                                onClick={onCancelIdiInspection}
                                            >
                                                <i className="ri-close-line label-icon align-middle"></i> Cancel
                                            </button>
                                            }
                                            {fboState && fboState.canSubmit &&
                                            <button className="btn btn-secondary btn-label"
                                                disabled={loading}
                                                onClick={() => onSubmitIdiInspectionClick()}
                                            >
                                                <i className="ri-check-double-line label-icon align-bottom"></i> Submit
                                            </button>
                                            }
                                            {fboState && fboState.canInspectionInProcess &&
                                            <button className="btn btn-secondary btn-label"
                                                disabled={loading}
                                                onClick={() => onInspectionInProcessIdiInspectionClick()}
                                            >
                                                <i className="ri-check-double-line label-icon align-bottom"></i> {fboState && fboState.isReadyForReview ? "Return to Inspector" : "Inspection In Process"}
                                            </button>
                                            }
                                            {fboState && fboState.canReadyForReview &&
                                            <button className="btn btn-secondary btn-label"
                                                disabled={loading}
                                                onClick={() => onReadyForReviewIdiInspectionClick()}
                                            >
                                                <i className="ri-check-double-line label-icon align-bottom"></i> Ready For Review
                                            </button>
                                            }
                                            {fboState && fboState.canApprove &&
                                            <button className="btn btn-secondary btn-label"
                                                disabled={loading}
                                                onClick={() => onApproveIdiInspectionClick()}
                                            >
                                                <i className="ri-check-double-line label-icon align-bottom"></i> Approve
                                            </button>
                                            }
                                            {fboState && fboState.canCompleted &&
                                            <button className="btn btn-secondary btn-label"
                                                disabled={loading}
                                                onClick={() => onCompletedIdiInspectionClick()}
                                            >
                                                <i className="ri-check-double-line label-icon align-bottom"></i> Uploaded To Tawuniya
                                            </button>
                                            }
                                            {fboState && fboState.canClosed &&
                                            <button className="btn btn-secondary btn-label"
                                                disabled={loading}
                                                onClick={() => onClosedIdiInspectionClick()}
                                            >
                                                <i className="ri-check-double-line label-icon align-bottom"></i> Closed
                                            </button>
                                            }
                                            {fboState && fboState.canAborted &&
                                            <button className="btn btn-secondary btn-label"
                                                disabled={loading}
                                                onClick={() => onAbortedIdiInspectionClick()}
                                            >
                                                <i className="ri-check-double-line label-icon align-bottom"></i> Aborted
                                            </button>
                                            }
                                            {fboState && fboState.canAssignMe &&
                                            <button className="btn btn-primary btn-label"
                                                disabled={loading || loadingLocal}
                                                onClick={() => onAssignMeInspectionClick()}
                                            >
                                                <i className="ri-user-follow-line label-icon align-bottom"></i> Assign Me IDI Inspection
                                            </button>
                                            }
                                        </div>
                                    </div>
                                </CardHeader>
                                <CardBody className="border border-dashed border-end-0 border-start-0">
                                    <Row className="gy-2">
                                        <Col xxl={4} md={6}>
                                            <Label className="form-label">Inspection #</Label>
                                            <input type="text" className="form-control" readOnly={true}
                                                value={(fboState && fboState.idiInspection.inspectionNumber) || ""}
                                            />
                                        </Col>
                                        <Col xxl={4} md={6}>
                                            <Label className="form-label">Status</Label>
                                            <input type="text" className="form-control" readOnly={true}
                                                value={(fboState && fboState.idiInspection.status) || ""}
                                            />
                                        </Col>
                                        <Col xxl={4} md={6}>
                                            <Label className="form-label">Project State</Label>
                                            <input type="text" className="form-control" readOnly={true}
                                                value={(fboState && fboState.idiInspection.stateName) || ""}
                                            />
                                        </Col>
                                        {fboState && fboState.showInspector &&
                                        <Fragment>
                                            <Col xxl={4} md={6}>
                                                <Label className="form-label">Team Lead User{fboState && fboState.isInspectorRequired && <span className="required">*</span>}</Label>
                                                <select className={`form-select ${errors.teamLeadUserId ? "is-invalid" : ""}`} disabled={fboState && fboState.canEditInspector ? false : true}
                                                    title={errors.teamLeadUserId?.message}
                                                    value={(fboState && fboState.idiInspection.teamLeadUserId) || ""}
                                                    {...register("teamLeadUserId", { 
                                                        validate: (value) => {
                                                            if (fboState && fboState.isInspectorRequired && !value) {
                                                                return "Team Lead User is required";
                                                            }

                                                            return true;
                                                        }
                                                    })}
                                                    onChange={e => onTeamLeadChange(e.target.value)}
                                                >
                                                    <option value={0}>...</option>
                                                    {fboState && fboState.teamLeadUserList.map(function(item, index){
                                                        return (
                                                            <option key={index} value={item.id}>{item.fullName}</option>
                                                        );
                                                    })}
                                                </select>
                                            </Col>
                                            {fboState && fboState.idiInspection.isActualInspection &&
                                            <Col xxl={4} md={6}>
                                                <Label className="form-label">Visit Type{fboState && fboState.isInspectorRequired && <span className="required">*</span>}</Label>
                                                <select className={`form-select ${errors.visitType ? "is-invalid" : ""}`} disabled={fboState && fboState.canEditInspector ? false : true}
                                                    title={errors.visitType?.message}
                                                    value={(fboState && fboState.idiInspection.visitType) || ""}
                                                    {...register("visitType", { 
                                                        validate: (value) => {
                                                            if (fboState && fboState.isInspectorRequired && !value) {
                                                                return "Visit Type is required";
                                                            }

                                                            return true;
                                                        }
                                                    })}
                                                    onChange={e => onIdiInspectionChange("visitType", e.target.value)}
                                                >
                                                    <option value="">...</option>
                                                    <option value="Usual Visit">Usual Visit</option>
                                                    <option value="Re-Visit">Re-Visit</option>
                                                    <option value="Additional Visit">Additional Visit</option>
                                                    <option value="Usual Visit - Portal">Usual Visit - Portal</option>
                                                    <option value="RD7">RD7</option>
                                                    <option value="ADV Not RD5">ADV Not RD5</option>
                                                    <option value="RD5">RD5</option>
                                                    <option value="RD0">RD0</option>
                                                    <option value="Rescheduled by Client">Rescheduled by Client</option>
                                                    <option value="Not on Portal">Not on Portal</option>
                                                </select>
                                            </Col>
                                            }
                                            <Col xxl={12} md={12}></Col>
                                        </Fragment>
                                        }
                                        {fboState && fboState.showInspection &&
                                        <Fragment>
                                            {fboState && fboState.idiInspection.isActualInspection &&
                                            <Col xxl={4} md={6}>
                                                <Label className="form-label">Inspection Date{fboState && fboState.isInspectionRequired && <span className="required">*</span>}</Label>
                                                {fboState && fboState.canEditInspection &&
                                                <Fragment>
                                                    <Flatpickr className={`form-control flatpickr-input ${errors.inspectionDate ? (fboState && fboState.idiInspection.inspectionDate ? "" : "is-invalid") : ""}`}
                                                        title={errors.inspectionDate?.message}
                                                        value={(fboState && getFormattedDateTime(fboState.idiInspection.inspectionDate)) || ""}
                                                        onChange={([date]) => onIdiInspectionChange("inspectionDate", date)}
                                                        options={{
                                                            enableTime: true,
                                                            dateFormat: "m/d/Y H:i"
                                                        }}
                                                    />
                                                    <input type="hidden"
                                                        value={fboState && fboState.idiInspection.inspectionDate || ""} readOnly={true}
                                                        {...register("inspectionDate", { 
                                                            validate: () => {
                                                                if (fboState && fboState.isInspectionRequired && !fboState.idiInspection.inspectionDate) {
                                                                    return "Inspection Date is required";
                                                                }

                                                                return true;
                                                            }
                                                        })}
                                                    />
                                                </Fragment>
                                                }
                                                {fboState && !fboState.canEditInspection &&
                                                <input type="text" className="form-control" readOnly={true}
                                                    value={(fboState && getFormattedDateTime(fboState.idiInspection.inspectionDate)) || ""}
                                                />
                                                }
                                            </Col>
                                            }
                                            <Col xxl={4} md={6}>
                                                <Label className="form-label">Inspection Stage{fboState && fboState.isInspectionRequired && <span className="required">*</span>}</Label>
                                                <select className={`form-select ${errors.inspectionStage ? "is-invalid" : ""}`} disabled={fboState && fboState.canEditInspection ? false : true}
                                                    title={errors.inspectionStage?.message}
                                                    value={(fboState && fboState.idiInspection.inspectionStage) || ""}
                                                    {...register("inspectionStage", { 
                                                        validate: (value) => {
                                                            if (fboState && fboState.isInspectionRequired && !value) {
                                                                return "Inspection Stage is required";
                                                            }

                                                            return true;
                                                        }
                                                    })}
                                                    onChange={e => onIdiInspectionChange("inspectionStage", e.target.value)}
                                                >
                                                    <option value="">...</option>
                                                    <option value="In Process Inspection">In Process Inspection</option>
                                                    <option value="Final Inspection">Final Inspection</option>
                                                    <option value="Pending">Pending</option>
                                                    <option value="N/A">N/A</option>
                                                </select>
                                            </Col>
                                            <Col xxl={4} md={6}>
                                                <Label className="form-label">Inspection Type{fboState && fboState.isInspectionRequired && <span className="required">*</span>}</Label>
                                                <select className={`form-select ${errors.inspectionType ? "is-invalid" : ""}`} disabled={fboState && fboState.canEditInspection ? false : true}
                                                    title={errors.inspectionType?.message}
                                                    value={(fboState && fboState.idiInspection.inspectionType) || ""}
                                                    {...register("inspectionType", { 
                                                        validate: (value) => {
                                                            if (fboState && fboState.isInspectionRequired && !value) {
                                                                return "Inspection Type is required";
                                                            }

                                                            return true;
                                                        }
                                                    })}
                                                    onChange={e => onIdiInspectionChange("inspectionType", e.target.value)}
                                                >
                                                    <option value="">...</option>
                                                    <option value="In Process Inspection">In Process Inspection</option>
                                                    <option value="Non Conformance Surveillance">Non Conformance Surveillance</option>
                                                    <option value="Final Inspection">Final Inspection</option>
                                                </select>
                                            </Col>
                                            <Col xxl={4} md={6}>
                                                <Label className="form-label">Inspector Results{fboState && fboState.isInspectionRequired && <span className="required">*</span>}</Label>
                                                <select className={`form-select ${errors.inspectionResult ? "is-invalid" : ""}`} disabled={fboState && fboState.canEditInspection ? false : true}
                                                    title={errors.inspectionResult?.message}
                                                    value={(fboState && fboState.idiInspection.inspectionResult) || ""}
                                                    {...register("inspectionResult", { 
                                                        validate: (value) => {
                                                            if (fboState && fboState.isInspectionRequired && !value) {
                                                                return "Inspector Results is required";
                                                            }

                                                            return true;
                                                        }
                                                    })}
                                                    onChange={e => onIdiInspectionChange("inspectionResult", e.target.value)}
                                                >
                                                    <option value="">...</option>
                                                    <option value="Compliant">Compliant</option>
                                                    <option value="Non Compliant">Non Compliant</option>
                                                    <option value="Open Snags">Open Snags</option>
                                                    <option value="Open Snags">Open Snags: Accepted as Noted</option>
                                                </select>
                                            </Col>
                                            {fboState && fboState.idiInspection.isActualInspection &&
                                            <Fragment>
                                                <Col xxl={12} md={12} className="mt-4">
                                                    <h4>Mention the reports needed to be generated</h4>
                                                </Col>
                                                <Col xxl={12} md={12}>
                                                    <div className="form-check">
                                                        <input type="checkbox" className="form-check-input" disabled={fboState && fboState.canEditInspection ? false : true}
                                                            checked={(fboState && fboState.idiInspection.isInrReport) || false}
                                                            onChange={e => onIdiInspectionChange("isInrReport", e.target.checked)}
                                                        /> Inspection Report
                                                    </div>
                                                </Col>
                                                <Col xxl={12} md={12}>
                                                    <div className="form-check">
                                                        <input type="checkbox" className="form-check-input" disabled={fboState && fboState.canEditInspection ? false : true}
                                                            checked={(fboState && fboState.idiInspection.isRd5Report) || false}
                                                            onChange={e => onIdiInspectionChange("isRd5Report", e.target.checked)}
                                                        /> RD5
                                                    </div>
                                                </Col>
                                                <Col xxl={12} md={12}>
                                                    <div className="form-check">
                                                        <input type="checkbox" className="form-check-input" disabled={fboState && fboState.canEditInspection ? false : true}
                                                            checked={(fboState && fboState.idiInspection.isRd7Report) || false}
                                                            onChange={e => onIdiInspectionChange("isRd7Report", e.target.checked)}
                                                        /> RD7
                                                    </div>
                                                </Col>
                                                <Col xxl={12} md={12}>
                                                    <div className="form-check">
                                                        <input type="checkbox" className="form-check-input" disabled={fboState && fboState.canEditInspection ? false : true}
                                                            checked={(fboState && fboState.idiInspection.isNoReport) || false}
                                                            onChange={e => onIdiInspectionChange("isNoReport", e.target.checked)}
                                                        /> No Report
                                                    </div>
                                                </Col>
                                                {fboState && fboState.idiInspection.isNoReport &&
                                                <Col xxl={12} md={12}>
                                                    <Label className="form-label">Mention the reason for No Report</Label>
                                                    <input type="text" className="form-control" readOnly={fboState && fboState.canEditInspection ? false : true}
                                                        value={(fboState && fboState.idiInspection.isNoReportReason) || ""}
                                                        onChange={e => onIdiInspectionChange("isNoReportReason", e.target.value)}
                                                    />
                                                </Col>
                                                }
                                            </Fragment>
                                            }
                                        </Fragment>
                                        }
                                    </Row>
                                </CardBody>
                            </Card>
                            {fboState && fboState.showInspector &&
                            <Card className="mb-0">
                                <CardHeader className="border-0 d-flex align-items-center">
                                    <h5 className="card-title mb-0 flex-grow-1">Inspector Assignment</h5>
                                </CardHeader>
                                <CardBody className="border border-dashed border-end-0 border-start-0">
                                    <Row className="gy-2">
                                        {fboState && fboState.idiInspection.isActualInspection &&
                                        <Fragment>
                                            <Col xxl={4} md={6}>
                                                <Label className="form-label">Inspection Start Date{fboState && fboState.isInspectorRequired && <span className="required">*</span>}</Label>
                                                {fboState && fboState.canEditInspector &&
                                                <Fragment>
                                                    <Flatpickr className={`form-control flatpickr-input ${errors.startDate ? (fboState && fboState.idiInspection.startDate ? "" : "is-invalid") : ""}`}
                                                        title={errors.startDate?.message}
                                                        value={(fboState && getFormattedDateTime(fboState.idiInspection.startDate)) || ""}
                                                        onChange={([date]) => onIdiInspectionChange("startDate", date)}
                                                        options={{
                                                            enableTime: true,
                                                            dateFormat: "m/d/Y H:i"
                                                        }}
                                                    />
                                                    <input type="hidden"
                                                        value={fboState && fboState.idiInspection.startDate || ""} readOnly={true}
                                                        {...register("startDate", { 
                                                            validate: () => {
                                                                if (fboState && fboState.isInspectorRequired && !fboState.idiInspection.startDate) {
                                                                    return "Inspection Start Date is required";
                                                                }

                                                                return true;
                                                            }
                                                        })}
                                                    />
                                                </Fragment>
                                                }
                                                {fboState && !fboState.canEditInspector &&
                                                <input type="text" className="form-control" readOnly={true}
                                                    value={(fboState && getFormattedDateTime(fboState.idiInspection.startDate)) || ""}
                                                />
                                                }
                                            </Col>
                                            <Col xxl={4} md={6}>
                                                <Label className="form-label">Inspection End Date{fboState && fboState.isInspectorRequired && <span className="required">*</span>}</Label>
                                                {fboState && fboState.canEditInspector &&
                                                <Fragment>
                                                    <Flatpickr className={`form-control flatpickr-input ${errors.endDate ? (fboState && fboState.idiInspection.endDate ? "" : "is-invalid") : ""}`}
                                                        title={errors.endDate?.message}
                                                        value={(fboState && getFormattedDateTime(fboState.idiInspection.endDate)) || ""}
                                                        onChange={([date]) => onIdiInspectionChange("endDate", date)}
                                                        options={{
                                                            enableTime: true,
                                                            dateFormat: "m/d/Y H:i"
                                                        }}
                                                    />
                                                    <input type="hidden"
                                                        value={fboState && fboState.idiInspection.endDate || ""} readOnly={true}
                                                        {...register("endDate", { 
                                                            validate: () => {
                                                                if (fboState && fboState.isInspectorRequired && !fboState.idiInspection.endDate) {
                                                                    return "Inspection End Date is required";
                                                                }

                                                                return true;
                                                            }
                                                        })}
                                                    />
                                                </Fragment>
                                                }
                                                {fboState && !fboState.canEditInspector &&
                                                <input type="text" className="form-control" readOnly={true}
                                                    value={(fboState && getFormattedDateTime(fboState.idiInspection.endDate)) || ""}
                                                />
                                                }
                                            </Col>
                                            <Col xxl={4}></Col>

                                        </Fragment>
                                        }
                                        <Col xxl={4} md={6}>
                                            <Label className="form-label">Inspector</Label>
                                            {fboState && fboState.canEditInspector &&
                                            <Fragment>
                                                <Lookup
                                                    clearButton 
                                                    allowNew ={false}
                                                    id ={`fldInspectorLookup`}
                                                    url = {`GetIdiInspectorLookup?latitude=${fboState.idiProject.locationLatitude || ""}&longitude=${fboState.idiProject.locationLongitude || ""}`}
                                                    defaultSearch={fboState && fboState.idiInspection.inspectorUserId || ""}
                                                    placeholder= "Select Inspector..."
                                                    labelKey= {option => `${option.fullName || ""}`}
                                                    selected = {selectedInspector}
                                                    onChange = {(value) => onInspectorChange(value)}
                                                    renderMenu = {InspectorRenderer}
                                                    title={errors.inspectorUserId?.message}
                                                    inputProps={{
                                                        className: errors.inspectorUserId ? (selectedInspector.length > 0 ? "" : "is-invalid") : ""
                                                    }}
                                                />
                                                <input type="hidden"
                                                    value={fboState && fboState.idiInspection.inspectorUserId || ""} readOnly={true}
                                                    {...register("inspectorUserId", { required: "Inspector is required" })} 
                                                />
                                            </Fragment>
                                            }
                                            {fboState && !fboState.canEditInspector &&
                                            <input type="text" className="form-control" readOnly={true}
                                                value={(selectedInspector.length > 0 && selectedInspector[0].fullName) || ""}
                                            />
                                            }
                                        </Col>
                                        
                                        <Col xxl={4} md={6}>
                                            <Label className="form-label">Name</Label>
                                            <input type="text" className="form-control" readOnly={true}
                                                value={(selectedInspector.length > 0 && selectedInspector[0].fullName) || ""}
                                            />
                                        </Col>
                                        <Col xxl={4} md={6}>
                                            <Label className="form-label">Email</Label>
                                            <input type="text" className="form-control" readOnly={true}
                                                value={(selectedInspector.length > 0 && selectedInspector[0].email) || ""}
                                            />
                                        </Col>
                                        <Col xxl={4} md={6}>
                                            <Label className="form-label">Employee ID</Label>
                                            <input type="text" className="form-control" readOnly={true}
                                                value={(selectedInspector.length > 0 && selectedInspector[0].employeeId) || ""}
                                            />
                                        </Col>
                                        <Col xxl={4} md={6}>
                                            <Label className="form-label">Phone Number</Label>
                                            <input type="text" className="form-control" readOnly={true}
                                                value={(selectedInspector.length > 0 && selectedInspector[0].telephoneNumber) || ""}
                                            />
                                        </Col>
                                        <Col xxl={4} md={6}>
                                            <Label className="form-label">Mobile Number</Label>
                                            <input type="text" className="form-control" readOnly={true}
                                                value={(selectedInspector.length > 0 && selectedInspector[0].mobileNumber) || ""}
                                            />
                                        </Col>
                                        <Col xxl={12} md={12}>
                                            <Label className="form-label">Address</Label>
                                            <input type="text" className="form-control" readOnly={true}
                                                value={(selectedInspector.length > 0 && selectedInspector[0].fullAddress) || ""}
                                            />
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                            }
                            <Card className="mt-3 mb-3">
                                <CardHeader className="border-0 d-flex align-items-center">
                                    <h5 className="card-title mb-0 flex-grow-1 cursor-pointer" onClick={() => setProjectInformationCollapsed(!projectInformationCollapsed)}>
                                        {projectInformationCollapsed && <i className="ri-add-box-line align-bottom text-primary"></i>}
                                        {!projectInformationCollapsed && <i className="ri-checkbox-indeterminate-line align-bottom text-primary"></i>}
                                        Project Information ({projectInformationCollapsed ? "Expand" : "Collapse"})
                                    </h5>
                                </CardHeader>
                                <CardBody className="border border-dashed border-end-0 border-start-0 card-text">
                                    <Collapse isOpen={!projectInformationCollapsed} className="collapse">
                                        <Card className="mb-0 card-light">
                                            <CardHeader className="border-0 d-flex align-items-center">
                                                <h5 className="card-title mb-0 flex-grow-1">Basic Information</h5>
                                            </CardHeader>
                                            <CardBody className="border border-dashed border-end-0 border-start-0 text-dark">
                                                <Row className="gy-2">
                                                    <Col xxl={4} md={6}>
                                                        <Label className="form-label">Project #</Label>
                                                        <input type="text" className="form-control" readOnly={true}
                                                            value={(fboState && fboState.idiProject.projectNumber) || ""}
                                                        />
                                                    </Col>
                                                    <Col xxl={4} md={6}>
                                                        <Label className="form-label">Status</Label>
                                                        <input type="text" className="form-control" readOnly={true}
                                                            value={(fboState && fboState.idiProject.status) || ""}
                                                        />
                                                    </Col>
                                                    <Col xxl={4} md={6}>
                                                        <Label className="form-label">Lot Ref #</Label>
                                                        <input type="text" className="form-control" readOnly={true}
                                                            value={(fboState && fboState.idiProject.lotRefNo) || ""}
                                                        />
                                                    </Col>
                                                    <Col xxl={4} md={6}>
                                                        <Label className="form-label">Source Name</Label>
                                                        <input type="text" className="form-control" readOnly={true}
                                                            value={(fboState && fboState.idiProject.sourceName) || ""}
                                                        />
                                                    </Col>
                                                    <Col xxl={4} md={6}>
                                                        <Label className="form-label">Tawuniya Ref #</Label>
                                                        <input type="text" maxLength={256} className="form-control" readOnly={true}
                                                            value={(fboState && fboState.idiProject.tawuniyaRefNo) || ""}
                                                        />
                                                    </Col>
                                                    <Col xxl={4} md={6}>
                                                        <Label className="form-label">Balady Ref #</Label>
                                                        <input type="text" maxLength={256} className="form-control" readOnly={true}
                                                            value={(fboState && fboState.idiProject.baladyRefNo) || ""}
                                                        />
                                                    </Col>
                                                    <Col xxl={4} md={6}>
                                                        <Label className="form-label">Request For Proposal</Label>
                                                        <input type="text" maxLength={256} className="form-control" readOnly={true}
                                                            value={(fboState && fboState.idiProject.requestForProposal) || ""}
                                                        />
                                                    </Col>
                                                    <Col xxl={4} md={6}>
                                                        <Label className="form-label">Project Type</Label>
                                                        <input type="text" maxLength={256} className="form-control" readOnly={true}
                                                            value={(fboState && fboState.idiProject.projectType) || ""}
                                                        />
                                                    </Col>
                                                    <Col xxl={4} md={6}>
                                                        <Label className="form-label">Structure Type</Label>
                                                        <input type="text" maxLength={256} className="form-control" readOnly={true}
                                                            value={(fboState && fboState.idiProject.structureType) || ""}
                                                        />
                                                    </Col>
                                                    <Col xxl={4} md={6}>
                                                        <Label className="form-label">Project Cost</Label>
                                                        <input type="text" className="form-control" readOnly={true}
                                                            value={(fboState && fboState.idiProject.projectCost) || ""}
                                                        />
                                                    </Col>
                                                    <Col xxl={4} md={6}>
                                                        <Label className="form-label">Currency</Label>
                                                        <input type="text" maxLength={256} className="form-control" readOnly={true}
                                                            value={(fboState && fboState.idiProject.currencyName) || ""}
                                                        />
                                                    </Col>
                                                    <Col xxl={4} md={6}>
                                                        <Label className="form-label">Region</Label>
                                                        <input type="text" maxLength={256} className="form-control" readOnly={true}
                                                            value={(fboState && fboState.idiProject.region) || ""}
                                                        />
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                        </Card>
                                        <Card className="mb-0 card-light">
                                            <CardHeader className="border-0 d-flex align-items-center">
                                                <h5 className="card-title mb-0 flex-grow-1">Location Information</h5>
                                            </CardHeader>
                                            <CardBody className="border border-dashed border-end-0 border-start-0 text-dark">
                                                <Row className="gy-2">
                                                    <Col xxl={12} md={12}>
                                                        <Label className="form-label">Address</Label>
                                                        <div className="d-flex gap-2">
                                                            <input type="text" maxLength={256} className="form-control" readOnly={true}
                                                                value={(fboState && fboState.idiProject.locationAddress) || ""}
                                                            />
                                                            {fboState &&
                                                            <button className="btn btn-primary btn-icon float-end"
                                                                onClick={() => setShowGoogleMap(true)}
                                                            >
                                                                <i className="ri-map-pin-line"></i>
                                                            </button>
                                                            }
                                                        </div>
                                                    </Col>
                                                    <Col xxl={3} md={6}>
                                                        <Label className="form-label">Country</Label>
                                                        <input type="text" maxLength={256} className="form-control" readOnly={true}
                                                            value={(fboState && fboState.idiProject.locationCountry) || ""}
                                                        />
                                                    </Col>
                                                    <Col xxl={3} md={6}>
                                                        <Label className="form-label">City</Label>
                                                        <input type="text" maxLength={256} className="form-control" readOnly={true}
                                                            value={(fboState && fboState.idiProject.locationCity) || ""}
                                                        />
                                                    </Col>
                                                    <Col xxl={3} md={6}>
                                                        <Label className="form-label">State</Label>
                                                        <input type="text" maxLength={256} className="form-control" readOnly={true}
                                                            value={(fboState && fboState.idiProject.locationState) || ""}
                                                        />
                                                    </Col>
                                                    <Col xxl={3} md={6}>
                                                        <Label className="form-label">Zip Code</Label>
                                                        <input type="text" maxLength={256} className="form-control" readOnly={true}
                                                            value={(fboState && fboState.idiProject.locationZipCode) || ""}
                                                        />
                                                    </Col>
                                                    <Col xxl={3} md={6}>
                                                        <Label className="form-label">Latitude</Label>
                                                        <input type="text" className="form-control" readOnly={true}
                                                            value={(fboState && fboState.idiProject.locationLatitude) || ""}
                                                        />
                                                    </Col>
                                                    <Col xxl={3} md={6}>
                                                        <Label className="form-label">Longitude</Label>
                                                        <input type="text" className="form-control" readOnly={true}
                                                            value={(fboState && fboState.idiProject.locationLongitude) || ""}
                                                        />
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                        </Card>
                                        <Card className="mb-0 card-light">
                                            <CardHeader className="border-0 d-flex align-items-center">
                                                <h5 className="card-title mb-0 flex-grow-1">Customer Information</h5>
                                            </CardHeader>
                                            <CardBody className="border border-dashed border-end-0 border-start-0 text-dark">
                                                <Row className="gy-2">
                                                    <Col xxl={4} md={6}>
                                                        <Label className="form-label">Customer</Label>
                                                        <input type="text" className="form-control" readOnly={true}
                                                            value={(selectedCustomer.length > 0 && selectedCustomer[0].code) || ""}
                                                        />
                                                    </Col>
                                                    
                                                    <Col xxl={4} md={6}>
                                                        <Label className="form-label">Name</Label>
                                                        <input type="text" className="form-control" readOnly={true}
                                                            value={(selectedCustomer.length > 0 && selectedCustomer[0].fullName) || ""}
                                                        />
                                                    </Col>
                                                    <Col xxl={4} md={6}>
                                                        <Label className="form-label">Email</Label>
                                                        <input type="text" className="form-control" readOnly={true}
                                                            value={(selectedCustomer.length > 0 && selectedCustomer[0].email) || ""}
                                                        />
                                                    </Col>
                                                    <Col xxl={4} md={6}>
                                                        <Label className="form-label">Phone Number</Label>
                                                        <input type="text" className="form-control" readOnly={true}
                                                            value={(selectedCustomer.length > 0 && selectedCustomer[0].telephoneNumber) || ""}
                                                        />
                                                    </Col>
                                                    <Col xxl={4} md={6}>
                                                        <Label className="form-label">Mobile Number</Label>
                                                        <input type="text" className="form-control" readOnly={true}
                                                            value={(selectedCustomer.length > 0 && selectedCustomer[0].mobileNumber) || ""}
                                                        />
                                                    </Col>
                                                    <Col xxl={4} md={6}>
                                                        <Label className="form-label">Fax Number</Label>
                                                        <input type="text" className="form-control" readOnly={true}
                                                            value={(selectedCustomer.length > 0 && selectedCustomer[0].faxNumber) || ""}
                                                        />
                                                    </Col>
                                                    <Col xxl={12} md={12}>
                                                        <Label className="form-label">Address</Label>
                                                        <input type="text" className="form-control" readOnly={true}
                                                            value={(selectedCustomer.length > 0 && selectedCustomer[0].fullAddress) || ""}
                                                        />
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                        </Card>
                                        <Card className="mb-0 card-light">
                                            <CardHeader className="border-0 d-flex align-items-center">
                                                <h5 className="card-title mb-0 flex-grow-1">Owner Information</h5>
                                            </CardHeader>
                                            <CardBody className="border border-dashed border-end-0 border-start-0 text-dark">
                                                <Row className="gy-2">
                                                    <Col xxl={4} md={6}>
                                                        <Label className="form-label">Owner Code</Label>
                                                        <input type="text" className="form-control" readOnly={true}
                                                            value={(selectedOwner.length > 0 && selectedOwner[0].code) || ""}
                                                        />
                                                    </Col>
                                                    
                                                    <Col xxl={4} md={6}>
                                                        <Label className="form-label">Name</Label>
                                                        <input type="text" className="form-control" readOnly={true}
                                                            value={(selectedOwner.length > 0 && selectedOwner[0].fullName) || ""}
                                                        />
                                                    </Col>
                                                    <Col xxl={4} md={6}>
                                                        <Label className="form-label">Email</Label>
                                                        <input type="text" className="form-control" readOnly={true}
                                                            value={(selectedOwner.length > 0 && selectedOwner[0].email) || ""}
                                                        />
                                                    </Col>
                                                    <Col xxl={4} md={6}>
                                                        <Label className="form-label">Phone Number</Label>
                                                        <input type="text" className="form-control" readOnly={true}
                                                            value={(selectedOwner.length > 0 && selectedOwner[0].telephoneNumber) || ""}
                                                        />
                                                    </Col>
                                                    <Col xxl={4} md={6}>
                                                        <Label className="form-label">Mobile Number</Label>
                                                        <input type="text" className="form-control" readOnly={true}
                                                            value={(selectedOwner.length > 0 && selectedOwner[0].mobileNumber) || ""}
                                                        />
                                                    </Col>
                                                    <Col xxl={4} md={6}>
                                                        <Label className="form-label">Fax Number</Label>
                                                        <input type="text" className="form-control" readOnly={true}
                                                            value={(selectedOwner.length > 0 && selectedOwner[0].faxNumber) || ""}
                                                        />
                                                    </Col>
                                                    <Col xxl={12} md={12}>
                                                        <Label className="form-label">Address</Label>
                                                        <input type="text" className="form-control" readOnly={true}
                                                            value={(selectedOwner.length > 0 && selectedOwner[0].fullAddress) || ""}
                                                        />
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                        </Card>
                                    </Collapse>
                                </CardBody>
                            </Card>
                            
                            <IdiInspectionINR 
                                fboState={fboState}
                                getFormattedDate={getFormattedDate}
                                getFormattedDateTime={getFormattedDateTime}
                                onIdiInspectionInrChange={onIdiInspectionInrChange}
                                onQuestionChange={onQuestionChange}
                                onImageChange={onImageChange}
                                onImageFileChange={onImageFileChange}
                                onImageFileDelete={onImageFileDelete}
                            />

                            <IdiInspectionRD5
                                fboState={fboState}
                                getFormattedDate={getFormattedDate}
                                getFormattedDateTime={getFormattedDateTime}
                                onIdiInspectionRd5Change={onIdiInspectionRd5Change}
                                onImageChange={onImageChange}
                                onImageFileChange={onImageFileChange}
                                onImageFileDelete={onImageFileDelete}
                            />

                            <IdiInspectionRD7
                                fboState={fboState}
                                getFormattedDate={getFormattedDate}
                                getFormattedDateTime={getFormattedDateTime}
                                onIdiInspectionRd7Change={onIdiInspectionRd7Change}
                                onImageChange={onImageChange}
                                onImageFileChange={onImageFileChange}
                                onImageFileDelete={onImageFileDelete}
                            />

                            <IdiInspectionRD3
                                fboState={fboState}
                                getFormattedDate={getFormattedDate}
                                getFormattedDateTime={getFormattedDateTime}
                                getDateWithoutTimezone={getDateWithoutTimezone}
                                onIdiInspectionRd3Change={onIdiInspectionRd3Change}
                                onIdiInspectionRd3EntryChange={onIdiInspectionRd3EntryChange}
                            />

                            <IdiInspectionRD6
                                fboState={fboState}
                                getFormattedDate={getFormattedDate}
                                getFormattedDateTime={getFormattedDateTime}
                                onIdiInspectionRd6Change={onIdiInspectionRd6Change}
                            />
                            
                            {fboState && (fboState.canGenerateRd5Document || fboState.canGenerateRd7Document || fboState.canGenerateInspectionDocument || fboState.canGenerateRd3Document || fboState.canGenerateRd6Document || fboState.canGenerateBaladyDocument) &&
                            <div className="d-flex flex-wrap gap-2 mt-3 mb-3">
                                {fboState.canGenerateRd5Document && 
                                <button className="btn btn-dark btn-label me-2"
                                    disabled={loading}
                                    onClick={() => onGenerateDocument("CDR_RD5", false)}
                                >
                                    <i className="ri-check-double-line label-icon align-bottom"></i> Generate & Attach RD5
                                </button>
                                }
                                {fboState.canGenerateRd7Document && 
                                <button className="btn btn-dark btn-label me-2"
                                    disabled={loading}
                                    onClick={() => onGenerateDocument("CDR_RD7", false)}
                                >
                                    <i className="ri-check-double-line label-icon align-bottom"></i> Generate & Attach RD7
                                </button>
                                }
                                {fboState.canGenerateInspectionDocument && 
                                <button className="btn btn-dark btn-label ms-2"
                                    disabled={loading}
                                    onClick={() => onGenerateDocument("CDR_INR", false)}
                                >
                                    <i className="ri-check-double-line label-icon align-bottom"></i> Generate & Attach Inspection Report
                                </button>
                                }
                                {fboState.canGenerateRd3Document && 
                                <button className="btn btn-dark btn-label me-2"
                                    disabled={loading}
                                    onClick={() => onGenerateDocument("CDR_RD3", false)}
                                >
                                    <i className="ri-check-double-line label-icon align-bottom"></i> Generate & Attach RD3
                                </button>
                                }
                                {fboState.canGenerateRd6Document && 
                                <button className="btn btn-dark btn-label me-2"
                                    disabled={loading}
                                    onClick={() => onGenerateDocument("CDR_RD6", false)}
                                >
                                    <i className="ri-check-double-line label-icon align-bottom"></i> Generate & Attach RD6
                                </button>
                                }
                                {fboState.canGenerateBaladyDocument && 
                                <button className="btn btn-dark btn-label me-2"
                                    disabled={loading}
                                    onClick={() => onGenerateDocument("CDR_BALADY", false)}
                                >
                                    <i className="ri-check-double-line label-icon align-bottom"></i> Generate & Attach Balady
                                </button>
                                }
                            </div>
                            }
                            {fboState && (fboState.canApproveRd5Document || fboState.canApproveRd7Document || fboState.canApproveInspectionDocument || fboState.canApproveRd3Document || fboState.canApproveRd6Document || fboState.canApproveBaladyDocument) &&
                            <div className="d-flex flex-wrap gap-2 mt-3 mb-3">
                                {fboState.canApproveRd5Document && 
                                <button className="btn btn-dark btn-label me-2"
                                    disabled={loading}
                                    onClick={() => onGenerateDocument("CDR_RD5", true)}
                                >
                                    <i className="ri-check-double-line label-icon align-bottom"></i> Approve/Generate & Attach RD5
                                </button>
                                }
                                {fboState.canApproveRd7Document && 
                                <button className="btn btn-dark btn-label me-2"
                                    disabled={loading}
                                    onClick={() => onGenerateDocument("CDR_RD7", true)}
                                >
                                    <i className="ri-check-double-line label-icon align-bottom"></i> Approve/Generate & Attach RD7
                                </button>
                                }
                                {fboState.canApproveInspectionDocument && 
                                <button className="btn btn-dark btn-label ms-2"
                                    disabled={loading}
                                    onClick={() => onGenerateDocument("CDR_INR", true)}
                                >
                                    <i className="ri-check-double-line label-icon align-bottom"></i> Approve/Generate & Attach Inspection Report
                                </button>
                                }
                                {fboState.canApproveRd3Document && 
                                <button className="btn btn-dark btn-label me-2"
                                    disabled={loading}
                                    onClick={() => onGenerateDocument("CDR_RD3", true)}
                                >
                                    <i className="ri-check-double-line label-icon align-bottom"></i> Approve/Generate & Attach RD3
                                </button>
                                }
                                {fboState.canApproveRd6Document && 
                                <button className="btn btn-dark btn-label me-2"
                                    disabled={loading}
                                    onClick={() => onGenerateDocument("CDR_RD6", true)}
                                >
                                    <i className="ri-check-double-line label-icon align-bottom"></i> Approve/Generate & Attach RD6
                                </button>
                                }
                                {fboState.canApproveBaladyDocument && 
                                <button className="btn btn-dark btn-label me-2"
                                    disabled={loading}
                                    onClick={() => onGenerateDocument("CDR_BALADY", true)}
                                >
                                    <i className="ri-check-double-line label-icon align-bottom"></i> Approve/Generate & Attach Balady
                                </button>
                                }
                            </div>
                            }
                            {fboState && fboState.idiInspection.id > 0 &&
                                <IdiServiceDocumentGrid 
                                    serviceId={-15}
                                    refId={fboState.idiInspection.id}
                                    refName={"IDI_INSPECTION"}
                                    parentId={fboState.idiInspection.id}
                                    parentName={"IDI_INSPECTION"}
                                    isProduct={false}
                                    refreshAction={refreshAction}
                                    collapsed={"false"}
                                    canChange={fboState.canSave}
                                    onChange={onChangeDocument}

                                    showRd5Document={fboState.showRd5Document}
                                    canEditRd5Document={fboState.canEditRd5Document}
                                    isRd5DocumentRequired={fboState.isRd5DocumentRequired}

                                    showRd7Document={fboState.showRd7Document}
                                    canEditRd7Document={fboState.canEditRd7Document}
                                    isRd7DocumentRequired={fboState.isRd7DocumentRequired}
                                    
                                    showInspectionDocument={fboState.showInspectionDocument}
                                    canEditInspectionDocument={fboState.canEditInspectionDocument}
                                    isInspectionDocumentRequired={fboState.isInspectionDocumentRequired}

                                    showRd3Document={fboState.showRd3Document}
                                    canEditRd3Document={fboState.canEditRd3Document}
                                    isRd3DocumentRequired={fboState.isRd3DocumentRequired}

                                    showRd6Document={fboState.showRd6Document}
                                    canEditRd6Document={fboState.canEditRd6Document}
                                    isRd6DocumentRequired={fboState.isRd6DocumentRequired}

                                    showBaladyDocument={fboState.showBaladyDocument}
                                    canEditBaladyDocument={fboState.canEditBaladyDocument}
                                    isBaladyDocumentRequired={fboState.isBaladyDocumentRequired}
                                />
                            }

                            {fboState && fboState.idiProject.id > 0 &&
                                <CommentGrid refId={fboState.idiInspection.id} refName="IDI_INSPECTION" onCommentAdd={reloadAction} />
                            }
                        </Col>
                        
                        {fboState && fboState.idiProject.id > 0 &&
                        <Col lg={3}>
                            <ActionList id={fboState.idiInspection.id} name={"IDI_INSPECTION"} refreshAction={refreshAction} />
                        </Col>
                        }

                        <ConfirmModal message={"Are you sure you want to \"Submit\" the IDI Inspection?"} show={showSubmitModal} onCloseClick={onCloseModalClick} onYesClick={() => onSaveIdiInspection(false)} />

                        {fboState && fboState.isReadyForReview &&
                        <ConfirmModal message={"Are you sure you want to \"Return\" the IDI Inspection to the Inspector?"} show={showInspectionInProcessModal} onCloseClick={onCloseModalClick} onYesClick={() => onSaveIdiInspection(false)} />
                        }

                        {fboState && !fboState.isReadyForReview &&
                        <ConfirmModalAdvanced show={showInspectionInProcessModal} onCloseClick={onCloseModalClick} onYesClick={() => onSaveIdiInspection(false)}>
                            <div className="text-center pb-2">Are you sure you want to change the IDI Inspection status to "Inspection In Process"?</div>
                            <Col xxl={12} md={12} className="pb-2">
                                <div class="bg-light rounded p-3 mt-3">
                                    <div class="d-flex align-items-center mb-3">
                                        <i class="ri-list-check-3 text-primary mr-2" style={{fontSize:22}}></i>
                                        <strong>Inspection Start Checklist</strong>
                                    </div>

                                    <small class="text-muted d-block mb-3">
                                        Please ensure the following requirements have been completed before starting the inspection.
                                    </small>

                                    <div class="d-flex align-items-center mb-2">
                                        <i class="ri-check-fill text-success mr-2" style={{fontSize:30}}></i>
                                        <span>Required documents are complete.</span>
                                    </div>
                                    <div class="d-flex align-items-center mb-2">
                                        <i class="ri-check-fill text-success mr-2" style={{fontSize:30}}></i>
                                        <span>Design Review / DRR is accepted.</span>
                                    </div>
                                    <div class="d-flex align-items-center mb-2">
                                        <i class="ri-check-fill text-success mr-2" style={{fontSize:30}}></i>
                                        <span>Site readiness and location are verified.</span>
                                    </div>
                                </div>
                            </Col>
                        </ConfirmModalAdvanced>
                        }

                        <ConfirmModal message={"Are you sure you want to change the IDI Inspection status to \"Ready for Review\"?"} show={showReadyForReviewModal} onCloseClick={onCloseModalClick} onYesClick={() => onSaveIdiInspection(false)} />
                        <ConfirmModal message={"Are you sure you want to change the IDI Inspection status to \"Approved\"?"} show={showApproveModal} onCloseClick={onCloseModalClick} onYesClick={() => onSaveIdiInspection(false)} />
                        <ConfirmModal message={"Are you sure inspection report is \"Uploaded To Tawuniya\" and you want to change the IDI Inspection status to \"Completed\"?"} show={showCompletedModal} onCloseClick={onCloseModalClick} onYesClick={() => onSaveIdiInspection(false)} />
                        <ConfirmModal message={"Are you sure you want to change the IDI Inspection status to \"Closed\"?"} show={showClosedModal} onCloseClick={onCloseModalClick} onYesClick={() => onSaveIdiInspection(false)} />
                        <ConfirmModal message={"Are you sure you want to change the IDI Inspection status to \"Aborted\"?"} show={showAbortedModal} onCloseClick={onCloseModalClick} onYesClick={() => onSaveIdiInspection(false)} />
                        <ConfirmModal message={"Are you sure you want to \"Assign\" the IDI Inspection?"} show={showAssignMeModal} onCloseClick={onCloseModalClick} onYesClick={onAssignMeInspection} />
                        <ConfirmModal message={"Are you sure you want to \"Delete\" the Image?"} show={showDeleteImageModal} onCloseClick={onCloseImageFileDelete} onYesClick={onSaveImageFileDelete} />
                        <ConfirmModal message={"Are you sure you want to \"Generate\" the Document?"} show={showGenerateDocumentModal} onCloseClick={onCloseGenerateDocument} onYesClick={onSaveGenerateDocument} />

                        
                    </Row>
                </Container>
            </div>

            {fboState && showGoogleMap &&
            <GoogleMapModal
                show={showGoogleMap}
                onCloseClick={() => setShowGoogleMap(false)} 
                address={fboState.idiProject.address || ""}
                latitude={fboState.idiProject.locationLatitude || null}
                longitude={fboState.idiProject.locationLongitude || null}
            />
            }
        </Fragment>
    );
}

export default IdiInspectionEditScreen;